import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Avatar } from "primereact/avatar";
import { Tooltip } from "primereact/tooltip";
import CardComp from "../../component/card/cardComp";
import IconInputText from "../../component/iconInputText/iconInputText";
import { theme } from "../../theme/theme";
import { CardBodyTitle, Container, GlobalCardTitle } from "../global/global.style";
import FormDropdown from "../../component/dropdown/formDropdown";
import { SET_FORM_VALUE, SET_FORM_VALUEOBJ } from "../../redux/dataSubDomain/dataSubDomain.type";
import filterImage from "../../assests/filterImage.svg"
import { InputSwitch } from "primereact/inputswitch";
import TableComponent from "../../component/Tables/tableComponent";
import BreadCrumbComp from "../../component/breadCrumb/breadCrump";


function SubDomain() {
     const { steppersData } = useSelector((state) => state.crumbs)
  const { apiData, formData } = useSelector((state) => state.dataDomain)
  const [searchVal, setSearchVal] = useState("")
  const dispatch = useDispatch()
  const [tempDataDomain, setTempDataDomain] = useState(apiData.subDomain.data.data_assets)
  const [tableView, setTableView] = useState(false)
 const currentPage = 1
  const cardsPerPage = 6;  // Number of cards per page
  const cardHeight = 188;
  const indexOfLastCard = currentPage * cardsPerPage;
  const indexOfFirstCard = indexOfLastCard - cardsPerPage;

  useEffect(() => {
    let tempData = apiData.subDomain?.data?.data_assets?.length === 0?[]:JSON.parse(JSON.stringify(apiData?.subDomain?.data?.data_assets))
    if (searchVal !== "") {
      tempData = apiData?.subDomain?.data?.data_assets.filter((val) => val.data_asset_name.toLowerCase().includes(searchVal.toLowerCase()))
    }
    setTempDataDomain(tempData)
  }, [searchVal])

 

  const changeDetail = (e, type, value) => {
    switch (type) {
      case "multiSelect": {
        dispatch({
          type: SET_FORM_VALUE,
          payload: {
            formField: e.target.name,
            value: value
          }
        })
        break
      }
      case "number": {
        dispatch({
          type: SET_FORM_VALUE,
          payload: {
            formField: e.target.name,
            value: value
          }
        })
        break
      }
      case "text": {
        dispatch({
          type: SET_FORM_VALUE,
          payload: {
            formField: e.target.name,
            value: e.target.value
          }
        })
        break
      }
      case "dropdown": {
        dispatch({
          type: SET_FORM_VALUE,
          payload: {
            formField: e.target.name,
            value: value
          }
        })
        dispatch({
          type: SET_FORM_VALUEOBJ,
          payload: {
            formField: e.target.name,
            valueAsObj: e.target.value
          }
        })
        break
      }
      case "file": {
        dispatch({
          type: SET_FORM_VALUE,
          payload: {
            formField: e.target.name,
            value: e.target.files[0]
          }
        })
        break
      }
      default: console.log("No type present : " + type)
    }
  }
  const getTableColumns = () =>{
    return []
  }
  return <Container style={{ height: "90%" }}>
       <BreadCrumbComp items={steppersData.dataSubDomainSteps}  />
    <div className="grid">

    </div>


    <CardComp style={{ padding: "10px", marginTop: "10px", fontSize: "15pt", display: 'inline-block', width: "100%", height: cardHeight + "px", marginRight: '20px' }} title={
      <Fragment>
        <div className="grid" style={{ borderBottom: `1px solid ${theme.colors.primary}` }}>
          <div className="col-8"><GlobalCardTitle>{apiData.subDomain.data.sub_domain_name}</GlobalCardTitle></div>
          {/* <div className="col-4" style={{ textAlign: "right" }}>
            <div style={{ color: "#00000066", fontSize: "6pt" }}>Data Product Owner </div>
            <div style={{ color: "#000000", fontSize: "8pt" }}>{apiData?.subDomain?.data?.created_by}</div>

          </div> */}
        </div>
      </Fragment>
    }
    >
      <div style={{ overflowX: "visible", overflowY: "hidden", whiteSpace: "normal", fontSize: "10pt", height: + "px" }}>
        <div style={{ marginTop: "10px", marginBottom: "15px" }}><CardBodyTitle>Description</CardBodyTitle></div>
        {/* <Tooltip mouseTrack target=".subDomainDescription" /> */}
        <span style={{ fontSize: "12px" }} className="subDomainDescription" data-pr-tooltip={apiData.subDomain.data.description}>{apiData.subDomain.data.description}</span>
      </div>

    </CardComp>

    <CardComp
      title={
        <Fragment>
          <div className="grid" style={{ borderBottom: `1px solid ${theme.colors.primary}` }} >
            <div className="col-10"><GlobalCardTitle style={{ verticalAlign: "sub" }}>Data Assets</GlobalCardTitle></div>
            <div className="col-2" style={{ textAlign: "right" }}>
              <IconInputText iconPosition="left" style={{ width: "100%", height: "40px", margin: "0px" }} value={searchVal} onChange={(e) => { setSearchVal(e.target.value) }} iconName="pi-search" placeholderName="Search for Data Assets" />
            </div>
            {/* <div className="col-2" style={{ textAlign: "right" }}>
              <FormDropdown style={{ textAlign: "left", width: "100%", height: "40px", margin: "0px" , marginBottom: "5px" }} options={formData.country.options} placeholder='Select Country ' optionLabel="country" name="country" value={formData.country.valueAsObj} onChange={(e) => changeDetail(e, "dropdown", e.target.value.country)} />
            </div> */}
            {/* <div className="col-3">
              <div className="grid">
                <div className="col-4" style={{ textAlign: "center" }}>
                  <img style={{}} src={filterImage} alt="icon" width="36" height="40" onClick={(event) => { }} aria-controls="popup_menu_left" />
                </div>
                <div className="col-4" style={{ marginTop:"3%",fontSize: "14px", fontWeight: "400" }}>
                  <span>Table View  </span>
                </div>
                <div className="col-4" style={{ marginTop:"3%" }}>
                  <InputSwitch checked={tableView} onChange={(e) => {setTableView(!tableView)}} style={{ width: "40px", height: "16px", verticalAlign: "super" }} />
                </div>
              </div>

            </div> */}
          </div>
        </Fragment>

      } style={{ padding: "10px", marginTop: "10px" }}>
      <div className="grid">
        {tableView?<TableComponent scrollable scrollHeight="100%" checked={false} style={{ width: "100%", height: `${(window.innerHeight * 85) / 100}px`, }} tableData={[]} columns={getTableColumns()} />:tempDataDomain?.slice(indexOfFirstCard, indexOfLastCard).map((val) => {
          return <div
            className="col-4">
            <CardComp
              onClick={() => {
                // navigate(`/dataDomain`)
              }}
              style={{ border: "1px solid #E0E4FF", fontSize: "15pt", margin: "10px", marginRight: '20px', height: cardHeight + "px", boxShadow: " 0 4px 6px rgba(0, 0, 0, 0.1), 0 2px 4px rgba(0, 0, 0, 0.2)" }}
              title={<div style={{ borderBottom: "1px solid #E0E4FF", padding: "10px" }}>
                <span style={{ fontSize: "12pt" }}><Avatar shape="circle" icon="pi pi-database" />&nbsp;{val.data_asset_name}{val.created_at === undefined || val.created_at === null || val.created_at === "" ? "" : new Date().getFullYear() === new Date(val.created_at).getFullYear() &&
                  new Date().getMonth() === new Date(val.created_at).getMonth() &&
                  new Date().getDate() === new Date(val.created_at).getDate() ? <span style={{ marginLeft: "10px", verticalAlign: "middle", fontSize: "10px" }}>[New]</span> : ""}</span>
              </div>}
            >
              <div style={{ padding: "0 10px", height: (cardHeight) + "px", overflowX: "visible", overflowY: "hidden", whiteSpace: "normal", fontSize: "9pt" }}>
                {/* <Tooltip target=".subDomainDescription" /> */}
                <span className="subDomainDescription" data-pr-tooltip={val.description}>{val.description}</span>
              </div>

            </CardComp>
          </div>
        })}
      </div>
    </CardComp>
  </Container>

}
export default SubDomain
